<template>
  <div class="main-content-container container-fluid px-4">
    <div class="page-header row no-gutters py-4">
      <div class="col-8 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle"> Inventory \ <span class="ActiveURL">Handling Days Upload</span></span>
        <!-- <h3 class="page-title">upload Syncc data</h3> -->
      </div>
    </div>
    <d-card class="card-small mb-4">
      <!-- Card Header -->
      <d-card-header class="border-bottom">
        <h6 class="m-0">Handling Days Upload</h6>

        <!-- <router-link :to="{ name: 'user-setup'}">
          <button
            class="btn btn-md btn-primary"
            style="margin-left: 900px;background-color:white;margin-top:-40px;color:black;"
          >Dashboard</button>
        </router-link> -->
      </d-card-header>

      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-row>
            <d-col>
              <d-form id="pricing">
                <d-form-row>
                  <!-- Email
                <d-col md="12" class="form-group row">
                  <a-steps>
                    <a-step status="finish" title="Login">
                    <a-icon slot="icon" type="user" />
                  </a-step>
    <a-step status="finish" title="Verification">
      <a-icon slot="icon" type="solution" />
    </a-step>
    <a-step status="process" title="Pay">
      <a-icon slot="icon" type="loading" />
    </a-step>
    <a-step status="wait" title="Done">
      <a-icon slot="icon" type="smile-o" />
    </a-step>
  </a-steps>
                </d-col> -->
                      <d-col md="12" class="form-group row"  >
                    <label class="col-md-3 col-form-label">Panel *</label>
                    <div class="col-md-4">
                      <select class="form-control" @change="panelOnchange()" v-model="HandlingDay.DataModel.Data.PanelInfo">
                    <option style="padding:50px" v-for="Dropdown in HandlingDay.Masters.PanelList" :value="Dropdown"
                      :key="Dropdown.ReferenceNo" >{{ Dropdown.Name }}</option>
                    </select>
                    </div>
                 </d-col>

                                       <d-col md="12" class="form-group row"  >
                    <label class="col-md-3 col-form-label">Select Upload Option *</label>
                    <div class="col-md-4">
                      <select class="form-control" @change="UploadOptionOnchange()" v-model="HandlingDay.DataModel.UIData.UploadOptionOnchange">
                    <option style="padding:50px" v-for="Dropdown in HandlingDay.Masters.UploadOption" :value="Dropdown"
                      :key="Dropdown.ReferenceNo" >{{ Dropdown.Name }}</option>
                    </select>
                    </div>
                 </d-col>

             <d-col md="12" class="form-group row" v-if="HandlingDay.DataModel.Data.TotalHandlingDayScrapList > 0">
                    <label class="col-md-3 col-form-label">Total no. Of Recoreds from file</label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{HandlingDay.DataModel.Data.TotalHandlingDayScrapList}}</label>
                    </div>
                 </d-col>


                 <d-col md="12" class="form-group row" v-if="HandlingDay.DataModel.Data.HandlingDayScrapList > 0">
                    <label class="col-md-3 col-form-label">Total no. Of Recoreds from table</label>                    
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{HandlingDay.DataModel.Data.HandlingDayScrapList}}</label>
                    </div>
                 </d-col>
                 
                  <d-col md="12" class="form-group row" v-if="HandlingDay.DataModel.UIData.UploadOptionOnchange.Name=='Calculated File'">
                    <label class="col-md-3 col-form-label">Upload file *</label>
                    <div class="col-md-7" v-if="HandlingDay.DataModel.UIData.UploadedDataCount == 0">   
                     <!-- <ejs-uploader ref="uploadObj" :uploading="importExcel"   id='Noonfileupload' name="UploadFiles"></ejs-uploader> -->
                         <div class="button_group">
                          <a href="javascript:;" class="button_s my_file el-button button_s el-button--primary el-button--small" >
                          
                          <input type="file" id="avatar" @change="importExcel" name="avatar">
                          </a>
                          <d-button type="button" id="submit" title="Please Select the panel" class="btn-accent" @click="getQuery" style="margin-right:10px" :disabled="(HandlingDay.DataModel.Data.HandlingDayScrapList==0)" >upload Data</d-button>
                                <d-button type="button" id="submit" class="btn-accent" @click="ClearFileData">Cancel</d-button>
                          </div>
                    </div>
                     <div class="col-md-7" v-if="HandlingDay.DataModel.UIData.UploadedDataCount > 0">  
                         <div class="SuccessLabel">
                           <span class="material-icons"> done_all </span> {{ HandlingDay.DataModel.UIData.LoadedFileName }} file data uploaded Successfully 
                         </div>
                    </div>
                  </d-col>

                  <d-col md="12" class="form-group row" v-if="HandlingDay.DataModel.UIData.UploadOptionOnchange.Name=='Raw File'">
                    <label class="col-md-3 col-form-label">Upload Raw file *</label>
                    <div class="col-md-7" v-if="HandlingDay.DataModel.UIData.UploadedDataCount == 0">   
                     <!-- <ejs-uploader ref="uploadObj" :uploading="importExcel"   id='Noonfileupload' name="UploadFiles"></ejs-uploader> -->
                         <div class="button_group">
                          <a href="javascript:;" class="button_s my_file el-button button_s el-button--primary el-button--small" >
                          
                          <input type="file" id="avatar" @change="importExcelRaw" name="avatar">
                          </a>
                          <d-button type="button" id="submit" title="Please Select the panel" class="btn-accent" @click="getQuery" style="margin-right:10px"  :disabled="(HandlingDay.DataModel.Data.HandlingDayScrapList==0)">upload Data</d-button>
                                <d-button type="button" id="submit" class="btn-accent" @click="ClearFileData">Cancel</d-button>
                          </div>
                    </div>
                     <div class="col-md-7" v-if="HandlingDay.DataModel.UIData.UploadedDataCount > 0">  
                         <div class="SuccessLabel">
                           <span class="material-icons"> done_all </span> {{ HandlingDay.DataModel.UIData.LoadedFileName }} file data uploaded Successfully 
                         </div>
                    </div>
                  </d-col>

                      <!-- 
                        <div class style="text-align:center">
                        <d-button type="button" id="submit" title="Please Select the panel" :disabled="( HandlingDay.DataModel.Data.FromCountry ==null)" class="btn-accent" @click="HandlingDayData" style="margin-right:10px" >upload Data</d-button>
                        <d-button type="button" id="submit" class="btn-accent" @click="ClearUsersetup">Cancel</d-button>
                        </div>   -->


    


                </d-form-row>
                 <!-- <d-button type="button" id="submit" class="btn-accent" @click="getQuery">run</d-button> -->
                <br />
                <div class style="text-align:center"  v-if="HandlingDay.DataModel.UIData.UploadedDataCount >0">
                  <!-- <d-button type="button" id="submit" title="Please Select the panel" :disabled="(HandlingDay.DataModel.Data.PanelInfo.Country == null || HandlingDay.DataModel.Data.FromCountry ==null || HandlingDay.DataModel.UIData.TemplateIsAvailable)" class="btn-accent" @click="GetList" style="margin-right:10px" >Submit</d-button> -->
                  <d-button type="button" id="submit" class="btn-accent" @click="ClearUsersetup">Reset</d-button>
                </div>

              </d-form>
            </d-col>
          </d-row>
        </d-list-group-item>
      </d-list-group>
    </d-card>
    <div v-if="HandlingDay.PageLoad" class="load-container load1"><div class="loader">Loading...</div></div>
  </div>
</template>
<script>
import Utilities from "@/Utilities/Utilities";
import axios from "axios";
import xlsx from "xlsx";
import XLSX from 'xlsx';
export default {
  name: 'HandlingDay',
   data() {
    return {
      HandlingDay: {
        PageType: "Master",
        PageLoad: false, 
        DataModel: {
          Data: {
             QueryString:null,
            PanelInfo:{
              Name:null,
              Country:null
            },
            FromCountry:null,
            HandlingDayScrapList:[],
            Token:null,
            Curd:null,
            CreatedBy:0
          },
          UIData: {
            UploadOptionOnchange:{
              Name:null
            },
            TotalHandlingDayScrapList:0,
            mySteps:['Step 1', 'Step 2', 'Step 3'],
            currentStep:0,
            Template:[],
            minMaxList:[],
            AvailablityTemplate:[],
            AvailablityList:[],
            AvailablityTemplateCount:0,
            TemplateIsAvailable :false,
            FileName:"Template",
            LoadedFileName:"",
            AvailabilityFileName:"Template",
            UploadedDataCount:0
          },
        },
        SessionInfo: {
          PageInfo: {
            userId: 0,
          },
        },
        ErrorInfo: [
          {
            ErrorID: 1,
            ErrorName: "",
            ErrorMessage: "",
          },
        ],

        Masters: {
          CountryMaster:[],
          UploadOption:[
            {
              Name:"Raw File"
            },
            {
              Name:"Calculated File"
            },
          ],
          PanelList:[
            {
              Name : "Amazon UAEDirect",
              Country:"UAEDirect",
              Panel:"Amazon"
            },
            {
              Name : "Amazon India",
              Country:"India",
              Panel:"Amazon"
            },
            {
              Name : "Amazon IndiaDirect",
              Country:"IndiaDirect",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Australia",
              Country:"Australia",
              Panel:"Amazon"
            },
            {
              Name : "Amazon UAE",
              Country:"UAE",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Mexico",
              Country:"Mexico",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Canada",
              Country:"Canada",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Brazil",
              Country:"Brazil",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Singapore",
              Country:"Singapore",
              Panel:"Amazon"
            },
            {
              Name : "Amazon KSA",
              Country:"KSA",
              Panel:"Amazon"
            },
            {
              Name : "Jokoka",
              Country:"UAE",
               Panel:"Jokoka"
            },
            {
              Name : "StoreUS",
              Country:"UAE",
               Panel:"StoreUS"
            },
            {
              Name : "Noon UAE",
              Country:"UAE",
              Panel:"Noon"
            },
            {
              Name : "Noon KSA",
              Country:"KSA",
              Panel:"Noon"
            }
          ]
        },
      },
    };
  },

  mounted(){
      this.HandlingDay.SessionInfo.PageInfo.userId = sessionStorage.getItem("UserId");
       this.HandlingDay.DataModel.Data.CreatedBy = sessionStorage.getItem("UserId");
      // this.ListAllFromCountry();
  },
  methods: {
ClearFileData(){
     this.HandlingDay.DataModel.Data.FromCountry = null;
     this.HandlingDay.DataModel.UIData.UploadOptionOnchange={
       Name : null
     }
     this.HandlingDay.DataModel.Data.PanelInfo={
        Name : null,
        Country:null,
        Panel:null
     }
     this.HandlingDay.DataModel.Data.HandlingDayScrapList = 0;
     this.HandlingDay.DataModel.Data.TotalHandlingDayScrapList = 0;
     
     document.getElementById("pricing").reset();
},

panelOnchange(){

            this.HandlingDay.DataModel.UIData.Template=[];
            this.HandlingDay.DataModel.UIData.TemplateIsAvailable = false;
},

ClearUsersetup(){
            this.HandlingDay.DataModel.UIData.Template = [];
            this.HandlingDay.DataModel.UIData.TemplateIsAvailable = false;
            this.HandlingDay.DataModel.Data.HandlingDayScrapList = 0;
        this.HandlingDay.DataModel.Data.PanelInfo ={
          Name : null,
              Country:null
        }
        this.HandlingDay.DataModel.Data.FromCountry =null;
        this.HandlingDay.DataModel.UIData.UploadedDataCount= 0;
         document.getElementById("pricing").reset();
      },

getQuery()
{
      let vm = this;
      vm.HandlingDay.PageLoad = true;
      var Token = sessionStorage.getItem("Token");
      this.HandlingDay.DataModel.Data.Token = Token;
      this.HandlingDay.DataModel.Data.CRUD = "UploadHandlingDays";
      var dataString = JSON.stringify(this.HandlingDay.DataModel.Data);

      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.HandlingDay.PageLoad = false;
            vm.HandlingDay.DataModel.UIData.UploadedDataCount= vm.HandlingDay.DataModel.Data.HandlingDayScrapList;
            vm.$toaster.success("Updated Successfully.");
          } else {

          }
        })
        .catch(function (response) {
          console.log(response);
            vm.HandlingDay.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });
},


UpDateHandlingDaysMaster()
{
      let vm = this;
      vm.HandlingDay.PageLoad = true;
      var Token = sessionStorage.getItem("Token");
      this.HandlingDay.DataModel.Data.Token = Token;
      this.HandlingDay.DataModel.Data.CRUD = "AmazonAEMasterUpload";
      this.HandlingDay.DataModel.Data.QueryString = "update AmazonProductMaster tgt  , HandlingDaysMaster src SET tgt.Handling_Time =  src.HandlingDays , tgt.price = src.Price WHERE src.sku = tgt.seller_sku";
      var dataString = JSON.stringify(this.HandlingDay.DataModel.Data);
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.HandlingDay.PageLoad = false;
            vm.HandlingDay.DataModel.UIData.UploadedDataCount= response.data.Result;
            vm.ClearHandlingDaysMaster();
          } else {

          }
        })
        .catch(function (response) {
          console.log(response);
            vm.HandlingDay.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

},

ClearHandlingDaysMaster()
{
      let vm = this;
      vm.HandlingDay.PageLoad = true;
      var Token = sessionStorage.getItem("Token");
      this.HandlingDay.DataModel.Data.Token = Token;
      this.HandlingDay.DataModel.Data.CRUD = "AmazonAEMasterUpload";
      this.HandlingDay.DataModel.Data.QueryString = "truncate TABLE HandlingDaysMaster";
      var dataString = JSON.stringify(this.HandlingDay.DataModel.Data);
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.HandlingDay.PageLoad = false;
            vm.HandlingDay.DataModel.UIData.UploadedDataCount= response.data.Result;
            vm.$toaster.success("Updated Successfully.");
          } else {

          }
        })
        .catch(function (response) {
          console.log(response);
            vm.HandlingDay.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });
      },


      GetList(){
      let vm = this;
      vm.HandlingDay.PageLoad = true;
      var Token = sessionStorage.getItem("Token");
      this.HandlingDay.DataModel.Data.Token = Token;
      
      this.HandlingDay.DataModel.UIData.FileName = this.HandlingDay.DataModel.Data.PanelInfo.Name + " " + Date.now();
      this.HandlingDay.DataModel.UIData.AvailabilityFileName = this.HandlingDay.DataModel.Data.PanelInfo.Name + "UnAvailability" + " " + Date.now();
      this.HandlingDay.DataModel.UIData.AvailabilityTemplateFileName = this.HandlingDay.DataModel.Data.PanelInfo.Name + "Availability" + " " + Date.now();
      this.HandlingDay.DataModel.UIData.MinMaxFileName = this.HandlingDay.DataModel.Data.PanelInfo.Name + "Min and Max Pricing" + " " + Date.now();
      this.HandlingDay.DataModel.Data.CreatedBy = this.HandlingDay.SessionInfo.PageInfo.userId;
      var ListParameter = Utilities.JsonCopy(this.HandlingDay.DataModel.Data);

      ListParameter.HandlingDayScrapList = [];
      var dataString = null;

      if(this.HandlingDay.DataModel.Data.PanelInfo.Panel == "Noon")
      {
        ListParameter.CRUD = "GetNoonList";
        dataString = JSON.stringify(ListParameter);
        this.NoonTemplate(dataString);
      }
      else if(this.HandlingDay.DataModel.Data.PanelInfo.Panel == "Amazon")
      {
        ListParameter.CRUD = "GetAmazonList";
        dataString = JSON.stringify(ListParameter);
        this.AmazonTemplate(dataString);
      }
      },


      HandlingDayData(){
      let vm = this;
      var Token = sessionStorage.getItem("Token");
      this.HandlingDay.DataModel.Data.Token = Token;
      this.HandlingDay.DataModel.Data.CRUD = "Create";
      this.HandlingDay.DataModel.UIData.FileName = this.HandlingDay.DataModel.Data.PanelInfo.Name + " " + Date.now();
      var dataString = JSON.stringify(this.HandlingDay.DataModel.Data);
       vm.HandlingDay.PageLoad = true;
       vm.HandlingDay.DataModel.UIData.UploadedDataCount = 0;
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.HandlingDay.PageLoad = false;
            vm.$toaster.success("Save Successfully.");
              console.log(response.data.Result);  
            vm.HandlingDay.DataModel.UIData.UploadedDataCount = response.data.Result;
 
          } else {
              console.log(response.data.ErrorInfo);
              vm.HandlingDay.PageLoad = false;
              vm.$swal.fire("Oops...", "Incorrect Mobile No, Date or Amount !","error");
          }
        })
        .catch(function (response) {
          console.log(response);  
          vm.HandlingDay.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });
      },

  // UploadedDataCount

  
      NoonTemplate(dataString){
       let vm = this;
       
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.HandlingDay.PageLoad = false;
            vm.$toaster.success("Save Successfully.");
            // console.log(response.data.Result);
            var FullList = response.data.Result;
            var exportTemp= Utilities.JsonCopy(FullList.filter(c => c.price !=0));

              exportTemp.map(function(key,value){

                  vm.HandlingDay.DataModel.UIData.Template.push(Utilities.JsonCopy(key));

              // if(vm.HandlingDay.DataModel.Data.FromCountry.FromCountry == 'India')
              // {

              //   // 00304BAUXXB07G4CWK1D
              //   if(key.partner_sku.substring(5, 10) == 'BAIXX')
              //   {
              //     vm.HandlingDay.DataModel.UIData.Template.push(Utilities.JsonCopy(key));
              //   }
              // }
              // else
              // {
              //   if(key.partner_sku.substring(5, 10) == 'BAUXX')
              //   {
              //     vm.HandlingDay.DataModel.UIData.Template.push(Utilities.JsonCopy(key));
              //   }
              // }
            });

             vm.HandlingDay.DataModel.UIData.Template.map(function(key,value){

             var AvailabilityTemplate={
            country_code:key.country_code,
            id_partner:key.id_partner,
            partner_sku:key.partner_sku,
            psku_code:key.psku_code,
            x_noon_sku:key.x_noon_sku,
            noon_warehouse_code:'W00015767A',
            x_noon_title:null,
            x_noon_brand:null,
            current_stock_gross:null,
            current_processing_time:null,
            x_stock_status_reason:null,
            stock_gross:2,
            processing_time:"10_days"
          };

        var minMax={
        country_code : 	key.country_code,
        id_partner :	key.id_partner,
        psku_code	:key.psku_code,
        partner_sku	: key.partner_sku,
        current_price_min :	null,
        current_price_max	: null,
        price_min	: Math.ceil(key.price - ((10/100) * key.price)),
        price_max : Math.ceil(Number((10/100) * key.price) + Number(key.price))

        }
  
            vm.HandlingDay.DataModel.UIData.minMaxList.push(Utilities.JsonCopy(minMax));
            vm.HandlingDay.DataModel.UIData.AvailablityList.push(Utilities.JsonCopy(AvailabilityTemplate));

          });


            var UnAvailablityTemplate= Utilities.JsonCopy(FullList.filter(c => c.price ==0));  

              UnAvailablityTemplate.map(function(key,value){

             var AvailabilityTemplate={
            country_code:key.country_code,
            id_partner:key.id_partner,
            partner_sku:key.partner_sku,
            psku_code:key.psku_code,
            x_noon_sku:key.x_noon_sku,
            noon_warehouse_code:'W00015767A',
            x_noon_title:null,
            x_noon_brand:null,
            current_stock_gross:null,
            current_processing_time:null,
            x_stock_status_reason:null,
            stock_gross:0,
            processing_time:"10_days"
          };

            vm.HandlingDay.DataModel.UIData.AvailablityList.push(Utilities.JsonCopy(AvailabilityTemplate));

              });

            if(vm.HandlingDay.DataModel.UIData.AvailablityTemplate.length > 0)
            vm.HandlingDay.DataModel.UIData.AvailablityTemplateCount = true;

            if(vm.HandlingDay.DataModel.UIData.Template.length > 0)
            vm.HandlingDay.DataModel.UIData.TemplateIsAvailable = true;
          } else {
              console.log(response.data.ErrorInfo);
                vm.HandlingDay.PageLoad = false;
              vm.$swal.fire("Oops...", "Incorrect Data !","error");
          }
        })
        .catch(function (response) {
          console.log(response);
            vm.HandlingDay.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

    },

  
    AmazonTemplate(dataString){
       let vm = this;
        vm.HandlingDay.DataModel.Data.CRUD = "GetAmazonList";
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.HandlingDay.PageLoad = false;
            vm.$toaster.success("Save Successfully.");
            // console.log(response.data.Result);

            response.data.Result.map(function(key,value){

                key.minimum_seller_allowed_price=Math.ceil(key.price - ((10/100) * key.price));	
                key.maximum_seller_allowed_price=Math.ceil(Number((10/100) * key.price) + Number(key.price));

            });

            vm.HandlingDay.DataModel.UIData.Template = response.data.Result;
            
            if(vm.HandlingDay.DataModel.UIData.Template.length > 0)
            vm.HandlingDay.DataModel.UIData.TemplateIsAvailable = true;
          } else {
              console.log(response.data.ErrorInfo);
                vm.HandlingDay.PageLoad = false;
              vm.$swal.fire("Oops...", "Incorrect Mobile No, Date or Amount !","error");
          }
        })
        .catch(function (response) {
          console.log(response);
            vm.HandlingDay.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

    },

    UploadOptionOnchange()
    {

    },

    getHeader(sheet) {
      const XLSX = xlsx;
      const headers = [];
      const range = XLSX.utils.decode_range(sheet["!ref"]); // worksheet['!ref'] Is the valid range of the worksheet
      let C;
      /* Get cell value start in the first row */
      const R = range.s.r; //Line / / column C
      let i = 0;
      for (C = range.s.c; C <= range.e.c; ++C) {
        var cell =
          sheet[
            XLSX.utils.encode_cell({ c: C, r: R })
          ]; /* Get the cell value based on the address  find the cell in the first row */
        var hdr = "UNKNOWN" + C; // replace with your desired default
        // XLSX.utils.format_cell Generate cell text value
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        if(hdr.indexOf('UNKNOWN') > -1){
          if(!i) {
            hdr = '__EMPTY';
          }else {
            hdr = '__EMPTY_' + i;
          }
          i++;
        }
        headers.push(hdr);
      }
      return headers;
    },
    /**
     * Import table
     */

importExcelRaw(e) {

      const files = e.target.files;
      this.HandlingDay.PageLoad = true;
      this.HandlingDay.DataModel.UIData.LoadedFileName = files[0].name;
      if (!files.length) {
        return ;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.HandlingDay.PageLoad = false;
        return alert("The upload format is incorrect. Please upload xls or xlsx format");
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          console.log(ev);
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // Generate JSON table content，wb.Sheets[Sheet名]    Get the data of the first sheet
          const excellist = []; // Clear received data
          // Edit data

          // var loopCount =  ws.length/20000


          this.HandlingDay.DataModel.Data.HandlingDayScrapList = 0 ;
          this.HandlingDay.DataModel.Data.QueryString = "INSERT INTO `HandlingDaysMasterTemp` (`SKU`, `HandlingDays`,`Price`,`Panel`,`CreatedBy`) VALUES";


          // for (var i = 0; i < loopCount; i++) {

          // }
          // Current_Time	
          // ASIN	
          // TIME	
          // TIME2	
          // Arrives	
          // Fastest_delivery	
          // Shipping	
          // Seller_FBA	
          // day


          this.HandlingDay.DataModel.Data.TotalHandlingDayScrapList = ws.length;
          for (var i = 0; i < ws.length; i++) {


            var ScrabData={
         Current_Time:null,
          ASIN:null,	
          TIME:null,	
          TIME2:null,	
          Arrives:null,	
          Fastest_delivery:null,
          Shipping:null,	
          Seller_FBA:null,	
          day:null
            }


            if(ws[i].Current_Time !=undefined)
            {
                ScrabData.Current_Time = ws[i].Current_Time;
            }
            else
            {
              ScrabData.Current_Time = null;
            }

            if(ws[i].ASIN !=undefined)
            {
                ScrabData.ASIN = ws[i].ASIN;
            }
            else
            {
              ScrabData.ASIN = null;
            }

            if(ws[i].SKU !=undefined)
            {
                ScrabData.SKU = ws[i].SKU;
            }
            else
            {
              ScrabData.SKU = null;
            }
// SKU
            if(ws[i].TIME !=undefined)
            {
                ScrabData.TIME = ws[i].TIME;
            }
            else
            {
              ScrabData.TIME = null;
            }


            if(ws[i].TIME2 !=undefined)
            {
                ScrabData.TIME2 = ws[i].TIME2;
            }
            else
            {
              ScrabData.TIME2 = null;
            }

            if(ws[i].Arrives !=undefined)
            {
                ScrabData.Arrives = ws[i].Arrives;
            }
            else
            {
              ScrabData.Arrives = null;
            }

            
            if(ws[i].Fastest_delivery !=undefined)
            {
                ScrabData.Fastest_delivery = ws[i].Fastest_delivery;
            }
            else
            {
              ScrabData.Fastest_delivery = null;
            }

            
            if(ws[i].Shipping !=undefined)
            {
                ScrabData.Shipping = ws[i].Shipping;
            }
            else
            {
              ScrabData.Shipping = null;
            }

            if(ws[i].Seller_FBA !=undefined)
            {
                ScrabData.Seller_FBA = ws[i].Seller_FBA;
            }
            else
            {
              ScrabData.Seller_FBA = null;
            }

            if(ws[i].day !=undefined )
            {
                 ScrabData.day = ws[i].day;
            }
            else
            {
                ScrabData.day = 0;
            }

            // if(ws[i].HandlingDays !=undefined )
            // {
            //      ScrabData.HandlingDays = ws[i].HandlingDays;
            // }
            // else
            // {
            //     ScrabData.HandlingDays = 0;
            // }

            if(ws[i].Price !=undefined )
            {
                 ScrabData.Price = ws[i].Price;
            }
            else
            {
                ScrabData.Price = 0;
            }

            var selectedDate = null;
            if(ScrabData.Arrives!="")
            {
                selectedDate = ScrabData.Arrives;
            }
            else if(ScrabData.Fastest_delivery!="")
            {
                selectedDate = ScrabData.Fastest_delivery;
            }
            // if(ScrabData.Seller_FBA!=null)
            // {
            //     selectedDate = ScrabData.Seller_FBA;
            // }

            if((ScrabData.Arrives==null || ScrabData.Arrives=="") && (ScrabData.Arrives=="" || ScrabData.Arrives==null) && ScrabData.Seller_FBA =="these sellers")
              ScrabData.HandlingDays = 20;
            else
            {
                // console.log(selectedDate);
                if(selectedDate!=null)
                {
                  ScrabData.HandlingDays = this.DateCalcuation(selectedDate,ScrabData.Current_Time);
                }
            }
            
              


            ScrabData.CreatedBy = this.HandlingDay.SessionInfo.PageInfo.userId;

            // if(ScrabData.Arrives==null || ScrabData.Arrives==undefined || ScrabData.Arrives=="")
            // console.log(ScrabData); 

            if(ScrabData.HandlingDays !=undefined)
            {
              this.HandlingDay.DataModel.Data.QueryString = this.HandlingDay.DataModel.Data.QueryString + "(\'" + ScrabData.SKU + "\',\'" +ScrabData.HandlingDays + "\',\'" +ScrabData.Price + "\',\'"+this.HandlingDay.DataModel.Data.PanelInfo.Name + "\',\'" + ScrabData.CreatedBy + "\')";
                                                                                                                                            //  +this.GenericUpload.DataModel.Data.PanelInfo.Name + "\',\'" + ScrabData.CreatedBy + "\')";                                                                           
              this.HandlingDay.DataModel.Data.HandlingDayScrapList +=1;
            }
            
            if(i < (ws.length - 1))
            {
              if(ScrabData.HandlingDays !=undefined)
              {
                this.HandlingDay.DataModel.Data.QueryString = this.HandlingDay.DataModel.Data.QueryString+"," 
              }
            }
            // this.HandlingDay.DataModel.Data.HandlingDayScrapList.push(ScrabData);
            // excellist.push(ws[i]);
          }

          
           this.HandlingDay.DataModel.Data.QueryString = this.HandlingDay.DataModel.Data.QueryString+";"
          // console.log("Read results", this.HandlingDay.DataModel.Data.HandlingDayScrapList); // At this point, you get an array containing objects that need to be processed
          // Get header2-1
          const a = workbook.Sheets[workbook.SheetNames[0]];
          const headers = this.getHeader(a);
          console.log('headers', this.HandlingDay.DataModel.Data.HandlingDayScrapList);  
          this.HandlingDay.PageLoad = false;
          console.log(this.HandlingDay.DataModel.Data.QueryString); 
          // this.HandlingDay.DataModel.Data.QueryString = JSON.stringify(this.HandlingDay.DataModel.Data.QueryString); 
          // Get header2-2
        } catch (e) {
          console.log(e); 
            this.HandlingDay.PageLoad = false;
          return alert("Read failure!");;
        }
      };
      fileReader.readAsBinaryString(files[0]);
      var input = document.getElementById("upload");
    },


     importExcel(e) {

      const files = e.target.files;
      this.HandlingDay.PageLoad = true;
      this.HandlingDay.DataModel.UIData.LoadedFileName = files[0].name;
      if (!files.length) {
        return ;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.HandlingDay.PageLoad = false;
        return alert("The upload format is incorrect. Please upload xls or xlsx format");
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          console.log(ev);
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // Generate JSON table content，wb.Sheets[Sheet名]    Get the data of the first sheet
          const excellist = []; // Clear received data
          // Edit data

          // var loopCount =  ws.length/20000


          this.HandlingDay.DataModel.Data.HandlingDayScrapList = 0 ;
          this.HandlingDay.DataModel.Data.QueryString = "INSERT INTO `HandlingDaysMasterTemp` (`SKU`, `HandlingDays`,`Price`,`Panel`,`CreatedBy`) VALUES";


          // for (var i = 0; i < loopCount; i++) {

          // }


          for (var i = 0; i < ws.length; i++) {


            var ScrabData={
              SKU:null,
              HandlingDays:null,
              Price:0,
              CreatedBy:0
            }


            if(ws[i].SKU !=undefined)
            {
                ScrabData.SKU = ws[i].SKU;
          
            }
            else
            {
              ScrabData.SKU = null;
            }

            if(ws[i].HandlingDays !=undefined )
            {
                 ScrabData.HandlingDays = ws[i].HandlingDays;
            }
            else
            {
                ScrabData.HandlingDays = 0;
            }

            if(ws[i].Price !=undefined )
            {
                 ScrabData.Price = ws[i].Price;
            }
            else
            {
                ScrabData.Price = 0;
            }


           
             ScrabData.CreatedBy = this.HandlingDay.SessionInfo.PageInfo.userId;


            this.HandlingDay.DataModel.Data.QueryString = this.HandlingDay.DataModel.Data.QueryString + "(\'" + ScrabData.SKU + "\',\'" +ScrabData.HandlingDays + "\',\'" +ScrabData.Price + "\',\'"+this.HandlingDay.DataModel.Data.PanelInfo.Name + "\',\'" + ScrabData.CreatedBy + "\')";
                                                                                                                                            //  +this.GenericUpload.DataModel.Data.PanelInfo.Name + "\',\'" + ScrabData.CreatedBy + "\')";                                                                           
            if(i < (ws.length - 1))
            {
              this.HandlingDay.DataModel.Data.QueryString = this.HandlingDay.DataModel.Data.QueryString+"," 
            }
            this.HandlingDay.DataModel.Data.HandlingDayScrapList +=1;
            
            // this.HandlingDay.DataModel.Data.HandlingDayScrapList.push(ScrabData);
            //  excellist.push(ws[i]);
          }

          
           this.HandlingDay.DataModel.Data.QueryString = this.HandlingDay.DataModel.Data.QueryString+";"
          // console.log("Read results", this.HandlingDay.DataModel.Data.HandlingDayScrapList); // At this point, you get an array containing objects that need to be processed
          // Get header2-1
          const a = workbook.Sheets[workbook.SheetNames[0]];
          const headers = this.getHeader(a);
          console.log('headers', this.HandlingDay.DataModel.Data.HandlingDayScrapList);  
          this.HandlingDay.PageLoad = false;
           console.log(this.HandlingDay.DataModel.Data.QueryString); 
          // this.HandlingDay.DataModel.Data.QueryString = JSON.stringify(this.HandlingDay.DataModel.Data.QueryString); 
          // Get header2-2
        } catch (e) {
          console.log(e); 
            this.HandlingDay.PageLoad = false;
          return alert("Read failure!");;
        }
      };
      fileReader.readAsBinaryString(files[0]);
      var input = document.getElementById("upload");
    },

 previewFiles(e) {
          console.log("test");
          var files = e.target.files, f = files[0];
          var reader = new FileReader();
          reader.onload = function(e) {
            var data = new Uint8Array(e.target.result);
            var workbook = XLSX.read(data, {type: 'array'});
            let sheetName = workbook.SheetNames[0]
            /* DO SOMETHING WITH workbook HERE */
            console.log(workbook);
            let worksheet = workbook.Sheets[sheetName];
            console.log(XLSX.utils.sheet_to_json(worksheet));
          };
          reader.readAsArrayBuffer(f);
       },

    DateCalcuation(data2,CurrentDate){
         var MasterArray=[
            {
               No:1,
               FullName:"january",
               ShortName:"jan"
            },
            {
               No:2,
               FullName:"february",
               ShortName:"feb"
            },
            {
               No:3,
               FullName:"march",
               ShortName:"mar"
            },
            {
               No:4,
               FullName:"april",
               ShortName:"apr"
            },
            {
               No:5,
               FullName:"may",
               ShortName:"may"
            },
            {
               No:6,
               FullName:"june",
               ShortName:"jun"
            },
            {
               No:7,
               FullName:"july",
               ShortName:"jul"
            },
            {
               No:8,
               FullName:"august",
               ShortName:"aug"
            },
            {
               No:9,
               FullName:"september",
               ShortName:"sep"
            },
            {
               No:10,
               FullName:"october",
               ShortName:"oct"
            },
            {
               No:12,
               FullName:"november",
               ShortName:"nov"
            },
            {
               No:12,
               FullName:"december",
               ShortName:"dec"
            }
         ]

        var d = new Date(CurrentDate).getDate();

         var Result = 0;
         if(data2.search("-") >= 0)
         {
            if(data2.length > 11)
            {
               var DMonth = data2.slice((data2.search("-")+2), (data2.search("-")+5));
               
                  for(var i=0;i<12;i++)
                  {
                     if(DMonth.toLowerCase() == MasterArray[i].ShortName || DMonth.toLowerCase() == MasterArray[i].FullName)
                     {
                        var GetDate = data2.substr(-2);
                        var m = new Date(CurrentDate).getMonth();
                        m++;
                        if(m==MasterArray[i].No)
                        {
                           var d = new Date(CurrentDate).getDate();
                           var Value =  GetDate - d;
                          //  document.write("Handling time is " + Value + " for "+ data2 +" </br>");
                          Result = Value;
                        }
                        else if(m == 12 && MasterArray[i].No == 1)
                        {
                          var DateCount =  getDaysInMonth(m,new Date(CurrentDate).getFullYear());
                          var d = new Date(CurrentDate).getDate();
                          var Value =  Number(GetDate) + Number(DateCount - d);
                          // document.write("Handling time is " + Value + " for "+ data2 +" </br>");
                          Result = Value;
                        }
                        else if(m == 12)
                     {
                        MasterArray[i].No = MasterArray[i].No + 12;
                        
                        if(MasterArray[i].No > m)
                        {
                          var diff = (MasterArray[i].No - m);
                          var DateCount =0;
                          DateCount +=  getDaysInMonth(12,new Date(CurrentDate).getFullYear());       

                           if(diff>1)
                           {
                              var temp = (MasterArray[i].No-12);
                              for(var j=1;j<temp;j++)
                               DateCount +=  getDaysInMonth(j,(new Date(CurrentDate).getFullYear())+1);       
                           }
                           else
                           {
                              DateCount =  getDaysInMonth(m,(new Date(CurrentDate).getFullYear())+1);       
                           }

                           var d = new Date(CurrentDate).getDate();
                           var Value =  Number(GetDate) + Number(DateCount - d);
                          Result = Value;
                        }

                     }
                        else if(MasterArray[i].No > m)
                        {
                          var diff = (MasterArray[i].No- m);
                          var DateCount =0;
                           if(diff>1)
                           {
                              for(var j=m;j<=diff;j++)
                               DateCount +=  getDaysInMonth(j,new Date(CurrentDate).getFullYear());       
                           }
                           else
                           {
                              DateCount =  getDaysInMonth(m,new Date(CurrentDate).getFullYear());       
                           }
                          var d = new Date(CurrentDate).getDate();
                          var Value =  Number(GetDate) + Number(DateCount - d);
                          Result = Value;
                        }


                     }
                  }
            }
            else
            {
               var DMonth = data2.slice(0, 3);
               for(var i=0;i<12;i++)
               {
                  if(DMonth.toLowerCase() == MasterArray[i].ShortName || DMonth.toLowerCase() == MasterArray[i].FullName)
                  {
                     var GetDate = data2.substr(-2);
                     var m = new Date(CurrentDate).getMonth();
                     m++;

                     if(m==MasterArray[i].No)
                     {
                        var d = new Date(CurrentDate).getDate();
                        var Value =  GetDate - d;
                       Result = Value;
                     }
                     else if(m == 12 && MasterArray[i].No == 1)
                     {
                       var DateCount =  getDaysInMonth(m,new Date(CurrentDate).getFullYear());
                       var d = new Date(CurrentDate).getDate();
                       var Value =  Number(GetDate) + Number(DateCount - d);
                      Result = Value;
                     }
                  }
               }
            }
         }
         else if(data2.search(","))
         {
            var DMonth = data2.slice((data2.search(",")+2), (data2.search(",")+5));
               for(var i=0;i<12;i++)
               {
                  if(DMonth.toLowerCase() == MasterArray[i].ShortName || DMonth.toLowerCase() == MasterArray[i].FullName)
                  {
                     var GetDate = data2.substr(-2);
                     var m = new Date(CurrentDate).getMonth();
                     m++;
                     if(m==MasterArray[i].No)
                     {
                        var d = new Date(CurrentDate).getDate();
                        var Value =  GetDate - d;
                        Result = Value;
                     }
                     else if(m == 12 && MasterArray[i].No == 1)
                     {
                       var DateCount =  getDaysInMonth(m,new Date(CurrentDate).getFullYear());
                       var d = new Date(CurrentDate).getDate();
                       var Value =  Number(GetDate) + Number(DateCount - d);
                      Result = Value;
                     }

                  }
               }
         }
         
      function getDaysInMonth (month,year) {
      return new Date(year, month, 0).getDate();
      };

     return  Result;
    }


  }
}
</script>